// extracted by mini-css-extract-plugin
export default {"dialog-body":"redirect-dialog_dialog-body__Uw+zD"};